import { Box, InputAdornment, TextField } from "@mui/material";
import { Search } from "@mui/icons-material";
import { useDebouncedCallback } from "use-debounce";

function SearchBox({ label, onChange }) {
  const debounced = useDebouncedCallback((value) => {
    if (typeof onChange === 'function') {
      onChange(value);
    }
  }, 500);

  const handleChange = (event) => {
    const value = event.target.value.trim();
    debounced(value);
  };

  return (
    <Box
      display={"flex"}
      alignItems={"center"}
      justifyContent={{ md: "center" }}
      gap={2}
      sx={{ width: { xs: "100%", md: "300px" } }}
    >
      <TextField
        label={label}
        size="small"
        sx={{ width: { xs: "100%" } }}
        onChange={handleChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          )
        }}
      />
    </Box>
  );
}

export default SearchBox;
